import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number | undefined | null }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      const v = params[key];
      if (v === undefined || v === null || v === "") return;
      queryParams.append(key, String(v));
    });
  }
  return `${baseUrl}?${queryParams.toString()}`;
}

function getAnalytics(params: {
  country?: string;
  seller?: string;
  boutique?: string;
  startDate?: any;
  endDate?: any;
}) {
  const baseUrl = "analytics";
  const url = buildUrl(baseUrl, params);

  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching Analytics:", error);
  }
}

function getAnalyticsByBoutique(params: {
  country?: string;
  startDate?: any;
  endDate?: any;
  sellerId?: string;
}) {
  const url = buildUrl("analytics/boutiques", params);
  return getApiInstance().get(url);
}

export { getAnalytics, getAnalyticsByBoutique };
